<template>
		<div class="pt-3 pb-3">
			<div class="text-center"  v-if="popupBatchUpdate.isLoading">
				<img src="@/assets/loading-logo-animation.gif" style="width: 75px"/>
				
				<p class="font-weight-bold">{{$t('THE_SYSTEM_IS_LOADING')}}</p>
			</div>
			<div v-if="!popupBatchUpdate.isLoading">
				<span class="font-italic mx-3">{{$t("SELL_LIMIT_TITLE")}}</span>
				<div class="d-flex justify-content-between mx-3">
                    <v-radio-group v-model="updateOpts" row>
                        <v-radio :label="$t('RESTRICTION_BULK_UPDATE')" value="1" name="updateOpts"></v-radio>
						<v-radio :label="$t('RESTRICTION_BULK_DELETE')" value="2" name="updateOpts"></v-radio>
                    </v-radio-group>
                    <v-btn color="primary" @click="save()">
                        <template>{{ $t("UPDATE") }}</template>
                    </v-btn>
			    </div>
				<v-row class="m-0">
					<v-col sm="6">
						<label class="pb-1">{{ $t("ROOM_TYPE") }} *</label>
						<v-autocomplete
							@change="changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
							item-text="text"
							item-value="value"
							:items="listRoom"
							v-model="popupBatchUpdate.stopSell.roomSelect"
							outlined
							chips
							dense
							multiple
							>
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a
								class="text-primary"
								@click="popupBatchUpdate.stopSell.roomSelect = listRoom.map(e => e.value); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
								>{{$t('SELECT_ALL')}}</a> | <a
								class="text-primary"
								@click="popupBatchUpdate.stopSell.roomSelect = []; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
								>{{$t('UN_SELECT_ALL')}}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
								:input-value="item.selected"
								close
								@click:close="removeChips(index, popupBatchUpdate.stopSell.roomSelect); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
								@click="item.select; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">
								<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption"
								>(+{{ popupBatchUpdate.stopSell.roomSelect.length - 2 }})</span
								>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col sm="6">
						<label class="pb-1"> {{
							$t("CHANNEL_GROUP") }} *</label>
						<v-autocomplete item-text="text" item-value="value" :items="listOTAGroup" v-model.lazy="popupBatchUpdate.stopSell.applyOTAGroup" outlined
							chips dense multiple @change="changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">
							<template v-slot:prepend-item>
								<p class="mx-3 mt-1"> <a class="text-primary" @click="popupBatchUpdate.stopSell.applyOTAGroup = listOTAGroup.map(e => e.value); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">{{
									$t('SELECT_ALL') }}</a> | <a class="text-primary" @click="popupBatchUpdate.stopSell.applyOTAGroup = []; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">{{
				$t('UN_SELECT_ALL') }}</a>
								</p>
							</template>
							<template v-slot:selection="{ item, index }">
								<v-chip color="primary" v-if="index === 0 || index === 1" v-bind="item.attrs"
									:input-value="item.selected" close @click:close="removeChips(index, popupBatchUpdate.stopSell.applyOTAGroup); changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)"
									@click="item.select; changeRoomSelect(popupBatchUpdate.stopSell.roomSelect)">
									<span>{{ item.text }}</span>
								</v-chip>
								<span v-if="index === 2" class="grey--text caption">(+{{ popupBatchUpdate.stopSell.applyOTAGroup.length - 2 }})</span>
							</template>
							<template slot="no-data">
								<div class="no-data">{{ $t("NO_DATA") }}</div>
							</template>
						</v-autocomplete>
					</v-col>
				</v-row>
				<div class="w-100">
					<div class="d-sticky h-header-table d-flex">
						<div class="mr-auto d-flex align-items-center"> 	
							<div class="font-weight-bold text-primary text-uppercase px-3">
							</div>
						</div> 
						<div> 	
							<div class="small-gutters d-flex"> 	
								<div class="text-center font-weight-bold w-input-update" v-for="(item, key) in popupBatchUpdate.daysOfWeek" :key="key">{{ item.value }}</div> 	
							</div> 
						</div>
					</div>
					<!-- lặp tất cả các loại phòng được chọn -->
					<template v-if="
					listRoom.filter(temp => popupBatchUpdate.stopSell.roomSelect.includes(temp.value)).length > 0 &&
					listOTAGroup.filter(temp => popupBatchUpdate.stopSell.applyOTAGroup.includes(temp.value)).length > 0
					">
						<div class="px-3 pt-2" v-for="(room, roomIdx) in detailUpdateData" :key="roomIdx">
							<span class="font-weight-bold text-primary">
								{{ room.roomName }}
							</span>
							<template v-for="(ota, otaIndex) in room.otaGroup">
								<div class="mb-3" :key="otaIndex">
									<div class="d-flex justify-content-between mr-2">
										<span class="text-primary">
											{{ ota.otaGroupName }}
										</span>
										<div class="ml-3 d-flex align-center">
											<v-btn color="primary" x-small class="ml-1" :title="$t('COPY')"
												@click="copyMaster(ota.dates)">
												<i class="icon-copy_all fs-16"></i>
											</v-btn>
											<v-btn color="primary" x-small class="ml-1" :title="$t('PASTE')"
												@click="pasteMaster(roomIdx, otaIndex)" v-if="objectCopy">
												<i class="icon-content_paste fs-16"></i>
											</v-btn>
										</div>
									</div>
									<div class="d-flex mt-2" v-for="(item, i) in ota.dates" :key="i">
										<div class="mr-auto d-date d-flex align-items-center">
											<template v-if="otaIndex === 0 && roomIdx === 0">
												<date-picker :disabled-date="notBeforeToday" :confirm="true" :confirm-text="$t('CONFIRM')" :clearable="false"  
													:popup-class="'popup-calendar-desktop-detailhotel'" v-model="item.dateSelect" :lang="languageDate" :format="'DD/MM/YYYY'" 
													range placeholder="Select date range" @change="dateDetailChangeDate(roomIdx,otaIndex, i)">
												</date-picker>
												<i v-if="ota.dates.length > 1" class="icon-delete text-danger fs-16 ml-2 cursor" @click="removePeriodStopSell(item, i)"></i>
											</template>
											<template v-else>
												{{ _moment(item.dateSelect[0]).format("DD/MM/YYYY") }} -
												{{ _moment(item.dateSelect[1]).format("DD/MM/YYYY") }}
											</template>
										</div>
										<div class="small-gutters config-price" v-for="(day, idx) in item.daysOfWeek" :key="idx">
											<v-btn v-if="idx == 0" color="primary" @click="copyRoomDetail(item.daysOfWeek)" class="ml-1" :title="$t('COPY')" icon small><i class="icon-content_paste_go fs-16"></i></v-btn>
											<div class="w-input-update" v-if="updateOpts == '1'">
												<div v-if="day.disable">
													<b-form-input class="w-input-update text-right rounded"  outlined dense disabled></b-form-input>
												</div>
												<div v-else class="vertical-divider border-0">
													<b-form-input 
													class="w-input-update text-right rounded" 
													@keyup="(e) => formatInput(e, day)"
													@input="(e) => formatInput(e, day)"
													outlined 
													dense 
													v-model="day.value"
													></b-form-input>
												</div>
											</div>
											<div class="w-input-update" v-else>
												<div class="vertical-divider border-0">
													<b-select 
														v-model="day.value" 
														:options="options" 
														:disabled="day.disable"
													></b-select>
												</div>
											</div>
										</div>
									</div>
									<div class="pt-2" v-if="otaIndex === 0 && roomIdx === 0">
										<v-btn color="primary" outlined  x-small @click="addDatePriodStopSell()">
											<v-icon color="#173d8f" small>add</v-icon>
											<label class="has-action fs-10">{{ $t("ADD_DATE_RANGE") }}</label>
										</v-btn>
									</div>
								</div>
							</template>
							<hr v-if="roomIdx <= detailUpdateData.length - 2" class="mb-0 mr-2" />
						</div>
					</template>
					<template v-if="
						listRoom.filter(temp => popupBatchUpdate.stopSell.roomSelect.includes(temp.value)).length === 0
					">
						<v-col class="text-center">
							<p style="color: #484646">{{ $t("NO_DATA") }}</p>
						</v-col>
					</template>

					<template v-if="
						listRoom.filter(temp => popupBatchUpdate.stopSell.roomSelect.includes(temp.value)).length > 0 &&
						listOTAGroup.filter(temp => popupBatchUpdate.stopSell.applyOTAGroup.includes(temp.value)).length === 0
					">
						<v-col class="text-center">
							<p style="color: #484646">{{ $t("NO_CHANNEL_GROUP") }}</p>
						</v-col>
					</template>
				</div>
			</div>
			<div class="text-right p-3" v-if="!popupBatchUpdate.isLoading">
				<v-btn color="primary" @click="save()">
					<template>{{ $t("UPDATE") }}</template>
				</v-btn>
			</div>
		</div>
</template>
<script>
import moment from "moment";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { service } from "@/_services/SaleRoom/room-plan.service.js";
import { restriction } from "@/_services/SaleRoom/restriction.js";

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Input from "@/components/Utils/Input.vue";

export default {
	components: {
		"date-picker": DatePicker,
		 "input-text": Input,
	},
	data() {
		return {
			popupBatchUpdate: {
				isLoading: true,
				batchUpdateDialog: false,
				currentTabIndex: -1,
				currentRoomtypeIds: null,
				stopSell: {
					invalidDate: false,
					roomSelect: [],
					listOfPeriod: [],
					applyOTAGroup: [],
				},
				daysOfWeek: [
					{ code: "MON", value: this.$t("MONDAY") },
					{ code: "TUE", value: this.$t("TUESDAY") },
					{ code: "WED", value: this.$t("WEDNESDAY") },
					{ code: "THU", value: this.$t("THURSDAY") },
					{ code: "FRI", value: this.$t("FRIDAY") },
					{ code: "SAT", value: this.$t("SATURDAY") },
					{ code: "SUN", value: this.$t("SUNDAY") },
				],
				isChanged: 0
			},
			listRoom: [],
			listOTAGroup: [],
			systemLang: this.$i18n.locale,
			listDisableDayRoomStopSell: [],
			selectAllRoom: false,
			selectAllOtaGroup: false,
			detailUpdateData: [],
			objectCopy: null,
			updateOpts: '1',
			options: [
				{ text: this.$t('NO'), value: null },
        		{ text: this.$t('DELETE'), value: -1 }
			]
		};
	},
	created() {
		this.initialize();
	},
	watch: {
		popupBatchUpdate: {
			handler(val) {
				this.listDisableDayRoomStopSell = [];
				val.stopSell.listOfPeriod.forEach((x, index) => {
					this.listDisableDayRoomStopSell.push({
						MON: {
							disable: true,
						},
						TUE: {
							disable: true,
						},
						WED: {
							disable: true,
						},
						THU: {
							disable: true,
						},
						FRI: {
							disable: true,
						},
						SAT: {
							disable: true,
						},
						SUN: {
							disable: true,
						},
					});
					var start = moment(x.dateSelect[0], "YYYY-MM-DD");
					var end = moment(x.dateSelect[1], "YYYY-MM-DD");
					let day = moment.duration(end.diff(start)).asDays();
					if (day < 6) {
						while (start <= end) {
							let daysOfWeek = this.formatDateOfWeek(start);
							this.listDisableDayRoomStopSell[index][daysOfWeek].disable = false;
							start = moment(start).add(1, "day");
						}
					} else {
						this.listDisableDayRoomStopSell[index].MON.disable = false;
						this.listDisableDayRoomStopSell[index].TUE.disable = false;
						this.listDisableDayRoomStopSell[index].WED.disable = false;
						this.listDisableDayRoomStopSell[index].THU.disable = false;
						this.listDisableDayRoomStopSell[index].FRI.disable = false;
						this.listDisableDayRoomStopSell[index].SAT.disable = false;
						this.listDisableDayRoomStopSell[index].SUN.disable = false;
					}
				});
				if (val.stopSell.roomSelect.length !== this.listRoom.length) {
                    this.selectAllRoom = false
                } else {
                     this.selectAllRoom = true
                }

				if (val.stopSell.applyOTAGroup.length !== this.listOTAGroup.length) {
                    this.selectAllOtaGroup = false
                } else {
                     this.selectAllOtaGroup = true
                }

				this.calculatorData();
			},
			deep: true,
		},
		updateOpts() {
			this.detailUpdateData.forEach((room) => {
				room.otaGroup.forEach((row) => {
					row.dates.forEach((date) => {
						for (const day of date.daysOfWeek) {
							day.value = null;
						}
					});
				})
			});
			this.objectCopy = null;
			this.$forceUpdate();
		}
	},
	methods: {
		formatInput(event, day) {
			if (event.target) {
				let inputValue = event.target.value.replace(/\D/g, '');
				if (/^0+\d/.test(inputValue)) { 
					inputValue = inputValue.replace(/^0+/, '');
				}
				this.$set(day, "value", inputValue);
			}
			this.$forceUpdate();
		},
		removeChips(index, arr) {
            if (index >= 0) arr.splice(index, 1);
			this.detailUpdateData.isChanged += 1;
        },
		copyRoomDetail(dayOfWeek) {
			let firstEnabledValue = null;
			let foundFirst = false;

			for (let item of dayOfWeek) {
				if (!item.disable) {
					if (!foundFirst) {
						firstEnabledValue = item.value;
						foundFirst = true;
						continue;
					}
					this.$set(item, 'value', firstEnabledValue);
				}
			}
		},
		calculatorData() {
			this.detailUpdateData = [];
			let tempData = this.popupBatchUpdate.stopSell.roomSelect.map((roomId) => {
				let roomRow = { id: roomId };
				let roomName = this.listRoom.filter((room) => room.value == roomId)[0].text || '';
				roomRow.roomName = roomName;
				let otaGroupList = this.popupBatchUpdate.stopSell.applyOTAGroup.map((otaId) => {
					let dates = [];
					this.popupBatchUpdate.stopSell.listOfPeriod.forEach((period) => {
						let daysOfWeek = [];
						let days = ['MON','TUE','WED','THU','FRI','SAT','SUN'];
						days.forEach((day) => {
							daysOfWeek.push({
								apply: null,
								value: null,
								day: day,
								disable: true
							});
						});

						let start = moment(period.dateSelect[0], "YYYY-MM-DD");
						let end = moment(period.dateSelect[1], "YYYY-MM-DD");
						let dayCount = moment.duration(end.diff(start)).asDays();

						if (dayCount < 6) {
							let currentDate = moment(start);
							while (currentDate <= end) {
								let currentDayOfWeek = currentDate.format('ddd').toUpperCase();
								let dayObject = daysOfWeek.find(d => d.day === currentDayOfWeek);

								if (dayObject) {
									dayObject.disable = false;
									dayObject.apply = currentDate.format("YYYY-MM-DD");
								}
								currentDate = moment(currentDate).add(1, 'day');
							}
						} else {
							let targetDay = moment(start);
							while (targetDay <= end) {
								let currentDayOfWeek = targetDay.format('ddd').toUpperCase();
								let dayObject = daysOfWeek.find(d => d.day === currentDayOfWeek);
								if (dayObject) {
									dayObject.disable = false;
								}
								targetDay.add(1, 'day');
							}
						}
						dates.push({ dateSelect: period.dateSelect, daysOfWeek: daysOfWeek, greaterThanAWeek: dayCount >= 6});
					});
					let otaGroup = this.listOTAGroup.find((ota) => ota.value == otaId) || null;
					let otaGroupName = '';
					if (otaGroup != null) {
						otaGroupName = otaGroup.text;
						if (otaGroup.text != otaGroup.otas) {
							otaGroupName += ` (${otaGroup.otas})`;
						}
					}
					return { id: otaId, dates: dates, otaGroupName: otaGroupName };
				});
				roomRow.otaGroup = otaGroupList;
				return roomRow;
			});
			this.detailUpdateData = tempData;
		},
		copyMaster(dates) {
			this.objectCopy = dates;
		},
		pasteMaster(roomIdx, otaIdx) {
			let room = this.detailUpdateData[roomIdx];
			room.otaGroup[otaIdx].dates = JSON.parse(JSON.stringify(this.objectCopy));
		},
		dateDetailChangeDate(roomIdx, otaIdx, dateInx) {
			let dateChanged = this.detailUpdateData[roomIdx].otaGroup[otaIdx].dates[dateInx].dateSelect;
			let oldDate = this.popupBatchUpdate.stopSell.listOfPeriod[dateInx].dateSelect;

			this.detailUpdateData[roomIdx].otaGroup[otaIdx].dates[dateInx].dateSelect = oldDate;
			this.popupBatchUpdate.stopSell.listOfPeriod[dateInx].dateSelect = dateChanged;
		},
		checkAll(type, value) {
			this.popupBatchUpdate.stopSell[type] = [];
            if (value) {
				if (type === 'applyOTAGroup') {
					this.listOTAGroup.forEach(e => {
						this.popupBatchUpdate.stopSell.applyOTAGroup.push(e.value);
					});
				} else {
					this.listRoom.forEach(e => {
						this.popupBatchUpdate.stopSell.roomSelect.push(e.value);
					});
				}
                
            } else {
				if (type === 'applyOTAGroup') {
					this.popupBatchUpdate.stopSell.applyOTAGroup = [];
				} else {
					this.popupBatchUpdate.stopSell.roomSelect = [];
				}
                
            }
			this.changeRoomSelect(this.popupBatchUpdate.stopSell.roomSelect);
		},
		async initialize() {
			this.objectCopy = null;
			this.popupBatchUpdate.isLoading = true;
			let fromDateListOfPeriod = moment(this.currentDate).format("YYYY-MM-DD");
			let toDateListOfPeriod = moment(this.currentDate)
				.add(1, "day")
				.format("YYYY-MM-DD");

			this.popupBatchUpdate.stopSell.listOfPeriod = [];
			this.popupBatchUpdate.stopSell.applyOTAGroup = [];
			this.popupBatchUpdate.stopSell.listOfPeriod.push({
				id: this.popupBatchUpdate.stopSell.length + 1,
				dateSelect: [new Date(fromDateListOfPeriod), new Date(toDateListOfPeriod)],
				value: {
					MON: null,
					TUE: null,
					WED: null,
					THU: null,
					FRI: null,
					SAT: null,
					SUN: null,
				},
			});
			await syncota.getAllOTAGroup().then((res) => {
				if (res.responseCode === 0) {
					this.listOTAGroup = res.data.map((x) => {
						let otas = x.otas.map((ota) => ota.otaI18n.find(y => y.lang == this.defaultI18n).name).join(', ') || '';
						return {
							value: x.id,
							text: x.name,
							otas: otas,
							otaCode: x.code
						};
					});
					this.listOTAGroup = this.listOTAGroup.filter((x) => x.value && x.otaCode !== 'AIP');
					const roomRateUpdateStore = JSON.parse(localStorage.getItem("roomRateUpdate"));
					if (roomRateUpdateStore.OtaGroupId) {
						if (roomRateUpdateStore.OtaGroupId != -1) {
							this.popupBatchUpdate.stopSell.applyOTAGroup = [roomRateUpdateStore.OtaId];
						} else {
							delete roomRateUpdateStore.OtaGroupId;
							localStorage.setItem("roomRateUpdate", JSON.stringify(roomRateUpdateStore));
						}
					} else {
						this.popupBatchUpdate.stopSell.applyOTAGroup = this.listOTAGroup.map(e => e.value);
					}
					this.getAllRoomDefault();
				} else {
					_alert(res, this.$t(res.data), false);
				}
			});
		},
		async getAllRoomDefault() {
			await restriction.getAllRoomTyeHasRoomRate().then((res) => {
				if (res.responseCode == 0) {
					this.loadListRoom(res.data);
				}
			});
		},
		loadListRoom(data) {
            this.listRoom = [];
			this.popupBatchUpdate.stopSell.roomSelect = [];
            data = data.filter(room => room.parent == null);
			this.listRoom = this.listRoom.concat(
                data.map((room) => {
                    return {
                        value: room.id,
                        text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n).name,
                    };
                })
            );
			const params = JSON.parse(localStorage.getItem("roomRateUpdate"));
			if (params.roomId) {
				if (params.roomId == -1) {
				} else {
					this.popupBatchUpdate.stopSell.roomSelect = [params.roomId];
				}
			} else {
				this.popupBatchUpdate.stopSell.roomSelect.push(this.listRoom[0].value);
			}
			this.popupBatchUpdate.isLoading = false;
        },
		isValidInteger(value) {
			if (typeof value === 'string' || typeof value === 'number') {
				const num = Number(value);
				return !isNaN(num) && Number.isInteger(num);
			}
			return false;
		},
		checkValidate() {
			let valid = true;
			let body = [];
			let message = '';
			
			if (this.popupBatchUpdate.stopSell.roomSelect.length === 0 || this.popupBatchUpdate.stopSell.applyOTAGroup.length === 0) {
				valid = false;
				message = this.$t("PLEASE_COMPLETE_THE_FIELDS_MARKED");
				return {valid: valid, body: body, message: message}
			}
			let noted;
			this.popupBatchUpdate.stopSell.listOfPeriod.forEach((x) => {
				if (this.get_day_of_time(new Date(x.dateSelect[0]), new Date(x.dateSelect[1])) > 365) {
					valid = false;
					message = this.$t("UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR");
					return true
				}
				if (!noted) {
					noted = moment(x.dateSelect[1], "YYYY/MM/DD");
					return true;
				}
				if (moment(x.dateSelect[0], "YYYY/MM/DD") <= noted) {
					valid = false;
					message = this.$t("_BATCH_UPDATE.MESSAGE.OVERLAP_TIME");
				} else {
					noted = moment(x.dateSelect[1], "YYYY/MM/DD");
				}
			});
			let isBlank = true;
			this.detailUpdateData.forEach((room) => {
				let roomSell = {
					id: room.id
				}
				let otaGroupList = [];
				room.otaGroup.forEach((row) => {
					let otaGroup = {id: row.id};
					let dateList = [];
					row.dates.forEach((date) => {
						if (!date.greaterThanAWeek) {
							for (const day of date.daysOfWeek) {
								let dateRow = {};
								if (day.disable) {
									continue;
								}
								if (day.apply && this.isValidInteger(day.value)) {
									dateRow.apply = day.apply;
									dateRow.value = day.value;
									dateList.push(dateRow);
									isBlank = false;
								}
							}
						} else {
							let start = moment(date.dateSelect[0], "YYYY-MM-DD");
							let end = moment(date.dateSelect[1], "YYYY-MM-DD");

							let targetDay = moment(start);
							while (targetDay <= end) {
								let dateRow = {};
								let currentDayOfWeek = targetDay.format('ddd').toUpperCase();
								let dayObject = date.daysOfWeek.find(d => d.day === currentDayOfWeek);
								if (dayObject && this.isValidInteger(dayObject.value)) {
									dateRow.apply = targetDay.format("YYYY-MM-DD");
									dateRow.value = dayObject.value;
									isBlank = false;
									dateList.push(dateRow);
								}
								targetDay.add(1, 'day');
							}
						}
					});
					if (dateList.length > 0) {
						otaGroup.dates = dateList;
						otaGroupList.push(otaGroup);
					}
				})
				if (otaGroupList.length > 0) {
					roomSell.ota = otaGroupList;
					body.push(roomSell);
				}
			})
			if (isBlank) {
				valid = false;
				message = this.$t("DATA_BLANK");
			}
			return {valid: valid, body: body, message: message}
		},
		save() {
			if (this.updateOpts == '1') {
				this.bulkUpdate();
			}
			if (this.updateOpts == '2') {
				this.bulkDelete();
			}
		},
		bulkUpdate() {
			const response = this.checkValidate();
			if (!response.valid) {
				_alert("null", response.message);
				return
			}
			const body = response.body;
			this.popupBatchUpdate.isLoading = true;
			service.updateSellLimit(body)
			.then((res) => {
				_alert(res, this.$t(res.data), false);
			})
			.finally(
				() => (
				(this.popupBatchUpdate.isLoading = false)
				)
			);
		},
		bulkDelete() {
			const response = this.checkValidate();
			if (!response.valid) {
				_alert("null", response.message);
				return
			}
			const body = response.body;
			this.popupBatchUpdate.isLoading = true;
			service.deleteSellLimit(body)
			.then((res) => {
				_alert(res, this.$t(res.data), false);
			})
			.finally(
				() => (
				(this.popupBatchUpdate.isLoading = false)
				)
			);
		},
		formatDateOfWeek(date) {
			let dayOfWeek;
			switch (date.day()) {
				case 0: {
				dayOfWeek = "SUN";
				break;
				}
				case 1: {
				dayOfWeek = "MON";
				break;
				}
				case 2: {
				dayOfWeek = "TUE";
				break;
				}
				case 3: {
				dayOfWeek = "WED";
				break;
				}
				case 4: {
				dayOfWeek = "THU";
				break;
				}
				case 5: {
				dayOfWeek = "FRI";
				break;
				}
				case 6: {
				dayOfWeek = "SAT";
				break;
				}
			}
			return dayOfWeek;
		},
		addDatePriodStopSell() {
			let prevPeriod = this.popupBatchUpdate.stopSell.listOfPeriod[
				this.popupBatchUpdate.stopSell.listOfPeriod.length - 1
			];
			const tomorrow = new Date();
            tomorrow.setDate(new Date().getDate() + 365*2);
            if (new Date(moment(prevPeriod.dateSelect[1]).format("YYYY-MM-DD")) >= tomorrow) {
                return;
            }
			let from = moment(prevPeriod.dateSelect[1]).add(1, "day").format("YYYY-MM-DD");
			let to = moment(prevPeriod.dateSelect[1]).add(2, "day").format("YYYY-MM-DD");
			this.popupBatchUpdate.stopSell.listOfPeriod.push({
				id:
				this.popupBatchUpdate.stopSell.listOfPeriod[
					this.popupBatchUpdate.stopSell.listOfPeriod.length - 1
				].id + 1,
				dateSelect: [new Date(from), new Date(to)],
				value: {
					MON: null,
					TUE: null,
					WED: null,
					THU: null,
					FRI: null,
					SAT: null,
					SUN: null,
				},
			});
		},
		removePeriodStopSell(item, index) {
			this.popupBatchUpdate.stopSell.listOfPeriod.splice(index, 1);
		},
		_moment: moment,
	}
};
</script>